import { Chart as ChartJS, ArcElement, Tooltip} from 'chart.js';
import { Doughnut } from 'react-chartjs-2';

ChartJS.register(ArcElement, Tooltip);

function Donut() {
  
  const data = {
  labels: [
    'Community Allocation',
    'Team Allocation (Locked)',
    'Presale Allocation',
    'DEX and CEX listings'
  ],
  datasets: [{
    label: 'Tokens',
    data: [50000000, 5000000, 295000000, 150000000],
    backgroundColor: [
      'rgb(84, 215, 30)',
      'rgb(19, 152, 255)',
      'rgb(255, 235, 30)',
      'rgb(239, 68, 68)'
    ],
    hoverOffset: 4,
    spacing: 3,
    borderRadius: 8,
  }]
};
  return (

    <Doughnut data={data}/>
  )
}

export default Donut
